import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from './LanguageSwitcher';

const Header: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const scrollToSection = (sectionId: string) => {
    const section = document.getElementById(sectionId);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false); // Mobil menüyü kapat
    }
  };

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ type: 'spring', stiffness: 120, damping: 20 }}
      className={`header ${isScrolled ? 'scrolled' : ''}`}
    >
      <div className="container">
        <nav className="navbar">
          <div className="nav-logo">
            <img src="/lolo.png" alt="SYMBA SECURETECH" />
          </div>
          <ul className="nav-menu">
            <li>
              <a href="#home" className="nav-link" onClick={(e) => {
                e.preventDefault();
                scrollToSection('home');
              }}>
                {t('nav.home')}
              </a>
            </li>
            <li>
              <a href="#products" className="nav-link" onClick={(e) => {
                e.preventDefault();
                scrollToSection('products');
              }}>
                {t('nav.products')}
              </a>
            </li>
            <li>
              <a href="#kurumsal" className="nav-link" onClick={(e) => {
                e.preventDefault();
                scrollToSection('kurumsal');
              }}>
                {t('nav.about')}
              </a>
            </li>
            <li>
              <a href="#contact" className="nav-link" onClick={(e) => {
                e.preventDefault();
                scrollToSection('contact');
              }}>
                {t('nav.contact')}
              </a>
            </li>
          </ul>
          
          <LanguageSwitcher />
          
          {/* Hamburger Menu Button */}
          <button 
            className="mobile-menu-toggle"
            onClick={toggleMobileMenu}
            aria-label="Toggle mobile menu"
          >
            <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
            <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
            <span className={`hamburger-line ${isMobileMenuOpen ? 'open' : ''}`}></span>
          </button>
        </nav>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isMobileMenuOpen && (
          <motion.div
            className="mobile-menu"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -20 }}
            transition={{ duration: 0.3 }}
          >
            <ul className="mobile-nav-menu">
              <li>
                <a href="#home" onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('home');
                }}>
                  {t('nav.home')}
                </a>
              </li>
              <li>
                <a href="#products" onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('products');
                }}>
                  {t('nav.products')}
                </a>
              </li>
              <li>
                <a href="#kurumsal" onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('kurumsal');
                }}>
                  {t('nav.about')}
                </a>
              </li>
              <li>
                <a href="#contact" onClick={(e) => {
                  e.preventDefault();
                  scrollToSection('contact');
                }}>
                  {t('nav.contact')}
                </a>
              </li>
            </ul>
            <div className="mobile-lang-switcher">
              <LanguageSwitcher />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};

export default Header;